import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import toast, { Toaster } from "react-hot-toast";
import LoadingButton from "@mui/lab/LoadingButton";

import { useForm } from "react-hook-form";
import { emailValidations } from "../../reactHookFormValidations";


import Box from "@mui/material/Box";
import CustomTextField from "../Global/CustomTextField";
import Typography from "@mui/material/Typography";
import { useQueryMagicLoginRequest } from "../../hooks/react-query/useData";
import { loginFormContainerStyles } from "../../jsxStyles";
import CreateAccountDialog from "./CreateAccountDialog";

// TODO remove, this demo shouldn't need to reset the theme.

export default function SignUp({ setIsCurrentForm }) {
  let [email, setEmail] = useState("");
  let [user, setUser] = useState({});
  const [open, setOpen] = useState("");
  const [linkSent, setLinkSent] = useState(false);

  const { refetch: requestMagicLogin, isLoading } =
  useQueryMagicLoginRequest({
    user,
  });


  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({});

  useEffect(() => {
    if (Object.keys(user).length !== 0) {
      (async () => {
          let response = await requestMagicLogin();
          if (response?.error?.message === "Network Error") {
            toast.error("Red no disponible");
            return;
          }
          toast.success("El enlace de ingreso fue enviado a su email");
          setLinkSent(true);
      })().catch((err) => {
        console.error(err);
      });
    }
  }, [user]);

  const onSubmit = async () => {
    setUser({ email });
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };


  return (
    <Box
      sx={{
        ...loginFormContainerStyles,
      }}
    >
      <CreateAccountDialog open={open} setOpen={setOpen} />

      <Toaster position="top-center" reverseOrder={false} />

      <Box className="login-form-container">
        {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar> */}
        <Typography
          variant="formTitle"
          sx={{ display: "block", textAlign: "center", fontSize: "28px" }}
        >
          Iniciar sesión{" "}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)} sx={{ margintop: "30px" }}>
          <CustomTextField
            helperText="Usuario"
            placeholder="Correo electrónico"
            errors={errors}
            register={register}
            validations={emailValidations}
            type="email"
            name="email"
            value={email}
            onChange={handleEmailChange}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: "17.38px",
              mb: "20.69px",
            }}
          >
 
          </Box>
          <LoadingButton
            type="submit"
            loading={isLoading}
            fullWidth
            variant="loginBtn"
            sx={{ mt: "28.47px", backgroundColor:"#800080"}}
          >
            ENVIAR ENLACE
          </LoadingButton>
          {linkSent && (
            <Typography sx={{ color: "white", mt: "7.89px" }}>
              Comprueba tu correo electrónico para obtener el enlace de inicio de sesión.
            </Typography>
          )}
            {false && (
          <>
            <Typography sx={{ color: "white", mt: "7.89px" }}>
              ¿No tienes cuenta para ingresar a nuestro portal?
            </Typography>
            <Button
              variant="createAccount"
              sx={{ p: "0", mt: "6px", fontSize: "1rem" }}
              onClick={() => setOpen(true)}
            >
              Crear Cuenta
            </Button>
          </>
        )}
        </form>
      </Box>
    </Box>
  );
}
